import { SET_TEMPLATE_LIST, SET_STAFF_LIST } from './mutation-types'

const state = {
  templateList: [],
  staffList: [],
}

const mutations = {
  [SET_TEMPLATE_LIST](state, payload) {
    state.templateList = payload
  },
  [SET_STAFF_LIST](state, payload) {
    state.staffList = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
